import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { localizedUrls } from "../../utils/i18n/localizedUrls";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { HudButtonFacebookConnect } from "../facebook/HudButtonFacebookConnect";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionLandingPageLogout } from "../landing-page/actionLandingPage";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { SettingsToggleSound } from "../sound/SettingsToggleSound";
import { ButtonSettingsPrimary } from "./ButtonSettingsPrimary";
import { SettingsToggleAnimation } from "./SettingsToggleAnimation";
var _TabSettings = function (_a) {
    var onLogOut = _a.onLogOut, onOpenMenu = _a.onOpenMenu, userName = _a.userName;
    var currLang = utilLoca.getCurrentLanguage();
    var supportUrl = localizedUrls.getLocalizedSupportUrl(currLang, userName);
    return (React.createElement("div", { className: "tab-settings__container-wrap" },
        React.createElement("div", { className: "tab-settings__container flex flex--row flex--wrap flex__align-start" },
            React.createElement("div", null,
                React.createElement(SettingsToggleSound, { soundGroup: IdSoundGroup.Sound })),
            React.createElement("div", null,
                React.createElement(SettingsToggleSound, { soundGroup: IdSoundGroup.Music })),
            React.createElement("div", null,
                React.createElement(SettingsToggleAnimation, null)),
            React.createElement("div", null,
                React.createElement(ButtonSettingsPrimary, { onClick: function () { return onOpenMenu(IdModal.Feedback); }, icon: IdIcon.FeedbackIcn, loca: IdLoca.settingsMenu_feedback })),
            React.createElement("div", null,
                React.createElement(ButtonSettingsPrimary, { onClick: function () { return window.open(supportUrl, "_blank"); }, icon: IdIcon.SupportIcn, loca: IdLoca.settingsMenu_support })),
            React.createElement("div", null,
                React.createElement(HudButtonFacebookConnect, null)),
            React.createElement("div", null,
                React.createElement(ButtonSettingsPrimary, { onClick: onLogOut, icon: IdIcon.LogOut_Icn, loca: IdLoca.tooltip_hud_logout_web })))));
};
var mapState = function (state) { return ({
    userName: state.playerInfo.name || "",
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onLogOut: actionLandingPageLogout,
        onOpenMenu: function (modalId) { return dispatch(actionModalOpen(modalId)); },
    }, dispatch);
};
export var TabSettings = connect(mapState, mapDispatch)(_TabSettings);



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/TabSettings.tsx
// module id = 2747
// module chunks = 3